import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        activeMenuItem: null,
        selectedMeteoSuchoFeature: {}
    },
    mutations: {
        setActiveMenuItem(state, menuItem) {
            state.activeMenuItem = menuItem;
        },
        setSelectedMeteoSuchoFeature(state, feature) {
            state.selectedMeteoSuchoFeature = feature
        }
    },
    actions: {
        setActiveMenuItem({ commit }, menuItem) {
            commit('setActiveMenuItem', menuItem);
        },
        setSelectedMeteoSuchoFeature({ commit}, feature) {
            commit('setSelectedMeteoSuchoFeature', feature)
        }
    },
    getters: {
        getActiveMenuItem(state) {
            return state.activeMenuItem;
        },
        getSelectedMeteoSuchoFeature(state) {
            return state.selectedMeteoSuchoFeature;
        }

    }
});

export default store;
